export default () => ({
  checklist: {
    checklist_title: '',
    checklist_description: null,
    entity_items: [],
    entity_types: [],
    entity_folders: [],
    categories: [],
    report_template: null,
    wordTemplateId: null,
    currentDraggingItem: {},
    itemDragChoosed: false,
    form: {},
    hasUserAutomatic: true,
    hasDatetimeAutomatic: true,
    hasEntityItemInHeader: true,
    status: 0,
    schedules: [],
    restrictions: null,
    editors: null,
    approvers: null,
    editableByAll: true,
    fillableByAll: true,
    autofill_entity: true,
    approvalsEnabled: false,
    approvalsEntitySpecificAssignments: false,
    fullTranslationLanguages: [],
    reportRestrictions: null,
    viewableByAll: true,
    viewableBySubmitter: false,
    locale: null,
    locale_detection_status: null,
    blurFaces: false,
    improveWriting: true,
  },

  stages: {
    build: {
      selectedItem: null,
    },
    settings: {
      setting: {
        active: 'schedules',
      },
    },
    report: {
      editedReportTemplate: null,
    },
  },

  schedules: [],
  approvalUsers: [],
  users: [],
  groups: [],
  entityItems: [],
  entityFolders: [],
  entityTypes: [],
  categories: [],
  report_templates: [],
  roles: [],
  languages: [],

  can_see_all_entity_items: false,

  activeStage: 0,

  isUpdating: false,

  checklistPreviousState: {
    restrictions: {
      groups: [],
      users: [],
      entity_items: [],
    },
    editors: {
      groups: [],
      users: [],
    },
    approvers: {
      users: [],
    },
  },
  modals: {
    delete_item: {
      open: false,
      item: null,
      parent: null,
    },
    edit_rocc_severity: {
      open: false,
      item: null,
    },
    edit_response_set: {
      open: false,
      response_set: null,
      type: null,
      item: null,
      isTranslationMode: false,
    },
    reorder_page: {
      open: false,
    },
    automatic_issues: {
      open: false,
      item: null,
      parent: null,
      after: null,
      prepend: false,
    },
    automatic_inspections: {
      open: false,
      item: null,
      parent: null,
      after: null,
      prepend: false,
    },
  },
  submitted: false,
  isCollapsible: false,
  isWordTemplateUploading: false,
});
